<template>
    <div>
        Voilà comment bien commencer ta journée ;)

        Pourquoi j'ai choisi de t'envoyer ce message maintenant ?
        <br>
        Nous sommes le 30, c'est notre mi-anniversaire ;)
        <br>
        De plus, si je rentre le 1er mai, théoriquement mon périple se finit dans pile 6 mois!

        Maintenant, place à mes sentiments...

        Depuis que je suis arrivé, et ce même avec toi, je me suis surpris à imaginer sans m'en rendre compte des
        situations de notre vie de couple à mon retour ^^.
        <br>
        Comme si on étaient installés déjà depuis pas mal de temps.
        <br>
        Et même encore maintenant, j'ai tendance à ramener toutes les situations qui m'arrivent, **à nous**.

        Chaque action que je fais, je m'imagine le faire avec toi.
        <br>
        C'est en même temps super motivant et joyeux, mais c'est en même temps super triste ^^ car l'attente est longue.
        <br>
        Quelques fois, même, ça fait un petit pincement au cœur.

        La cuisine! J'ai très hâte d'expérimenter avec toi les nouvelles choses que j'ai apprises, de nouveaux plats, de
        nouvelles saveurs :)
        <br>
        Ça nous changera des plats qu'on a l'habitude de faire et ça sera meilleur pour la santé :)
        <br>
        Tu pourra enfin manger sainement :o
        <br>
        Et surtout, j'aime la cuisine :D
        <br>
        D'ailleurs toi aussi tu m'a parlée de certains plats cool qu'on pourraient s'amuser à faire ensembles :)
        <br>
        On va pouvoir faire les courses aussi :)
        <br>Bon, c'est vrai que ça on l'a déjà fait, mais je nous imagine dans les rayons, tous les deux, à faire les
        courses de la semaine \*w\*

        Chaque fois que je regarde Netflix, je m'imagine aussi sur un canapé, avec toi blottie contre moi, et prête à
        t'endormir comme ça 😍
        <br>
        Ça m'a bien fais rire quand tu ma racontée ça toi aussi l'autre jour ^^

        Chaque fois que je me lève le matin et que je sors du lit, je t'imagine, comme à notre habitude sur ma gauche,
        mais malheureusement, personne n'est là :/
        <br>
        Je pense que me lever en ta compagnie est une des meilleure choses de la journée ;D
        <br>
        Rassure toi, me coucher avec toi dans le lit, arrive ex-æquo ;p.

        Quand je fais mon petit entrainement du matin, image être a cotée de moi, à m'encourager pour ces pecs et ces
        abdos tant demandés ;p.
        <br>
        Et après l'effort, le réconfort, des bisous partout, voir plus si affinité :$ ♥

        Et bien sur, Fortnite, quel plaisir de jouer directement avec toi à coté, c'est tellement plus simple, plus
        drôle et plus agréable.
        <br>
        Je regrette ce temps là.
        <br>
        J'adore jouer avec toi, n'importe quel type de jeu, tant que c'est avec toi ♥

        Et enfin, les repas, un bon repas en tête à tête, yeux dans les yeux, sur un plat que nous aimons tous les deux
        et qu'on a cuisiné ensemble.
        <br>
        Le rêve je te dis, le rêve ♥

        Je ne sais pas quand est ce que l'on pourra concrétiser ce rêve, mais soit-il loin ou proche, je pense que ce
        sera une des meilleures expériences de ma vie.
        <br>
        Je nous souhaite tout le bonheur possible et j'ai très très hâte.

        Qu'il y ait une grande distance ou pas, je te le répète encore, si tu as besoin d'une oreille, je suis là pour
        toi, pour t'écouter et pour te réconforter du mieux que je suis capable.

        Plus je suis loin de toi et plus je me rends compte de certaines choses.
        <br>
        Il y a en quelque sorte une remise en question de certaines de mes actions.
        <br>
        Pas forcément des actions mauvaise que j'ai faites (bien que cela en fasse partie) mais aussi des actions que
        j'aurais faites différemment avec le recul.
        <br>
        Plus j'y pense et plus je trouve des choses que je ferais différemment maintenant.
        <br>
        Et c'est pourquoi ça fait en quelque sorte du bien de pouvoir prendre ce recul, car en rentrant, j’espère
        pouvoir être un meilleur copain :)
        <br>
        J’espère être encore plus attentionné et te bourrer de bonheur ;)

        Voici qui conclus ce message que tu as tant attendue.
        <br>
        Je voulais y noter mon ressenti sur une plus longue période car cela exprime mieux ce que je ressent et j'ai pu
        te le partager.
        <br>
        Je suis très heureux avec toi, très heureux dans les moments difficile tant dans les moments agréables.
        <br>
        **_Se disputer change mon humeur, pas mes sentiments_**.
        <br>
        Rappelle toi toujours de cette phrase, elle est très importante.
        <br>
        Et se disputer nous fais avancer, cela détermine les points sur lesquels nous devons travailler pour atteindre
        l'harmonie parfaite.
        <br>
        Personnellement, j'y crois à cette harmonie. Je pense sincèrement que 2 personnes peuvent vivre sans jamais se
        disputer ^^.
        <br>
        C'est peut être utopique, mais j'y crois encore ;)

        Comme note de fin, je vais te raconter cette petite histoire, comme tu les aimait tant sur mon "blog" :p

        Un jour, un jeune garçon
        <br>
        Fou amoureux de sa moitié
        <br>
        Contraint, dût prendre l'avion
        <br>
        et ainsi la quitter

        Les mois passèrent,
        <br>
        L'attente était insoutenable
        <br>
        Les jours défilèrent
        <br>
        Je pensait ne pas en être capable

        C'est alors que vint la fin
        <br>
        Le jour tant attendu du retour
        <br>
        Il ne pensait alors plus qu'au bien
        <br>
        Que le ferait la vision de son amour

        Il fût l'heure de se lever
        <br>
        S'envoler de retour à Lyon
        <br>
        Je pense que je vais pleurer
        <br>
        En voyant ton visage si mignon

        ♥ ♥ ♥
    </div>
</template>

<script>
export default {
  name: 'MyText',
};
</script>

<style scoped>

</style>
